import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth, isCoach } from "@/context/AuthContext";
import api, { errMsg, tokens } from "@/lib/api";

function readHash() {
  const p = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  return { token: p.get("access_token"), type: p.get("type"), error: p.get("error_description") };
}

export default function SetPassword() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [{ token, type, error }] = useState(readHash);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/set-password", { access_token: token, new_password: pw });
      tokens.set(data.access_token, data.refresh_token);
      window.history.replaceState(null, "", "/set-password");
      setUser(data.user);
      toast.success("Password set - welcome to K-FitHUB");
      nav(isCoach(data.user) ? "/coach" : "/app");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 relative z-10">
      <form onSubmit={submit} className="w-full max-w-sm panel p-8 fade-up" data-testid="set-password-form">
        <div className="eyebrow mb-2">K-FitHUB</div>
        <h1 className="text-4xl font-bold uppercase">{type === "invite" ? "Create your password" : "Set a new password"}</h1>
        {!token ? (
          <p className="text-sm text-red-400 mt-4" data-testid="set-password-invalid">{error || "This link is invalid or has expired. Ask your coach for a new invite, or use Forgot password on the login page."}</p>
        ) : (
          <div className="space-y-4 mt-6">
            <div><Label>New password (min 8)</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1" data-testid="set-password-input" /></div>
            <div><Label>Confirm password</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1" data-testid="set-password-confirm-input" /></div>
            <Button type="submit" className="w-full" disabled={busy || pw.length < 8} data-testid="set-password-submit-btn">{busy ? "Saving…" : "Save password & sign in"}</Button>
          </div>
        )}
      </form>
    </div>
  );
}
